import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import { DeleteCategoryAsync } from "services/categories";
import { DeleteClass } from "services/classifications";
import i18next from "i18next";

export default function DeleteClassification() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(DeleteClass, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            message:
              i18next.language === "ar"
                ? "تم الحذف بنجاح"
                : "Deleted successfullys",
          });
          queryClient.invalidateQueries("classifications");
        }
      },
    }),
  };
}
